import { render, staticRenderFns } from "./SysLog.vue?vue&type=template&id=227a5539"
import script from "./SysLog.vue?vue&type=script&lang=js"
export * from "./SysLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports